export default __webpack_public_path__ + "static/media/Tiger's Vambraces of Stalking Fury.a686888c.jpg";